(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.cmPillarsReady === 'true') return;

    var grid = section.querySelector('.cm-pillars__grid');
    var bar = section.querySelector('.cm-pillars__scrollbar');
    var thumb = section.querySelector('.cm-pillars__scrollbar-thumb');
    if (!grid || !bar || !thumb) return;

    section.dataset.cmPillarsReady = 'true';

    function update() {
      var scrollW = grid.scrollWidth;
      var clientW = grid.clientWidth;
      if (scrollW <= clientW) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      var ratio = clientW / scrollW;
      var thumbW = Math.max(ratio * 100, 15);
      thumb.style.width = thumbW + '%';
      var maxScroll = scrollW - clientW;
      var pct = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      thumb.style.left = pct * (100 - thumbW) + '%';
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    if (window.cmBindCarouselScrollbar) {
      window.cmBindCarouselScrollbar(grid, bar, thumb);
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(update).observe(grid, { childList: true, subtree: true });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.cm-pillars').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
